import apiRequest, { HttpMethod, UserSub } from './apiRequest';

export const apiRequestTyped = async <T>(
  endpoint: string,
  userSub: UserSub = null,
  method: HttpMethod = 'GET',
  body?: Record<string, any> | null
): Promise<T> => {
  const result = await apiRequest(endpoint, userSub, method, body);
  return result as T;
};
